module.exports = __webpack_public_path__ + "static/media/less_logo.d07f5e9c.svg";